import React, { useContext } from 'react';

import { InternalOutputContext } from 'context/InternalOutputContext';

import { getTransactionAdminUrl } from 'utility/Debug/DebugInfo';

import styles from '../List.module.scss';

const DebugInfo = () => {
    const { showInternalOutput, transactionId } = useContext(
        InternalOutputContext
    );
    if (transactionId && showInternalOutput) {
        const adminUrl = getTransactionAdminUrl(transactionId);
        return (
            <div className={styles.Box} id="js-transaction-id-debug">
                {'Transaction Id: '}
                <span>{transactionId}</span>{' '}
                <a target="_blank" href={adminUrl} rel="noreferrer">
                    IBE-Admin
                </a>
            </div>
        );
    }

    return null;
};

export default DebugInfo;
